import React, { ReactNode, createContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useRoles } from '../../queries/roles';
import { withErrorHandler } from '../ErrorContext';

export type RolesContextType = {
  roles: any;
  isLoading: boolean;
  roleSwitchModalActive: boolean;
  setRoleSwitchModalActive: any;
  setMatchUuid: any;
  matchUuid: any;
};

const defaultState = {
  roles: [],
  isLoading: false,
  roleSwitchModalActive: false,
  setRoleSwitchModalActive: () => undefined,
  setMatchUuid: () => undefined,
  matchUuid: null,
};

export const RolesContext = createContext<RolesContextType>(defaultState);

export const RolesContextProvider = (props: {
  children: ReactNode;
  showGenericError: (...props: any) => void;
}) => {
  const history = useHistory();
  const [matchUuid, setMatchUuid] = useState(null);
  const [roleSwitchModalActive, setRoleSwitchModalActive] = useState(false);

  const {
    isLoading: isLoadingRoles,
    data: roles,
    error,
  } = useRoles(
    {
      matchId: matchUuid,
    },
    {
      enabled: Boolean(matchUuid),
    }
  );

  const isLoading = (!error && isLoadingRoles) || roles === undefined;

  useEffect(() => {
    if (error) {
      props.showGenericError(error, true, true);
      history.push('/matches');
    }
  }, [error]);

  return (
    <RolesContext.Provider
      {...props}
      value={{
        isLoading,
        roles,
        roleSwitchModalActive,
        setRoleSwitchModalActive,
        setMatchUuid,
        matchUuid,
      }}
    />
  );
};

export default withErrorHandler(RolesContextProvider);
